import logo from "assets/img/logo.png";
import { getStorage } from "store/local";
import funcs from "tools/functions";
import ChangeLang from "components/Tools/ChangeLang";

const Header = ({ viewLogo = false }) => {
  const session = getStorage("ctxSession");

  const imageLogo =
    session?.company_logo && session.company_logo.trim() !== ""
      ? funcs.base64ToBlobUrl(session.company_logo, "png")
      : null;

  return (
    <header className="shadow-md h-[72px] bg-neutral-800 flex justify-between items-center px-4 md:px-5 w-full">
      <div className="flex">
        <img
          className="mx-0 h-[40px]  my-auto object-contain"
          src={logo}
          alt="logo"
        />
        {imageLogo && viewLogo && (
          <div className="ml-[31px] pl-3 border-l border-gray-300">
            <img
              className="w-auto h-[40px]"
              src={imageLogo}
              width={140}
              alt="logo"
            />
          </div>
        )}
      </div>
      <div>
        <ChangeLang />
      </div>
    </header>
  );
};

export default Header;
